module.exports = __webpack_public_path__ + "1d92c01cf20c6a74aa45998d4fc72152.png";